import {usePlayers} from '@glark-newco/game-library';
import {_ReactPixi, Container, Sprite, Text} from '@pixi/react';
import {GlowFilter} from 'pixi-filters';
import {Assets} from 'pixi.js';
import {Fragment, PropsWithChildren, useMemo} from 'react';
import {RingSprite} from './RingSprite';
import {CLIP_BLUE, CLIP_GREEN, CLIP_RED, CLIP_YELLOW, POSTIT, WRITING_FONT} from '../assetManifest';
import {textStyle} from '../constants';
import {usePlayerObjectives} from '../state/PlayerObjectivesSlice';
import {RingColour} from '../SupplyChainPayloadTypes';

interface ObjectivePanelProps extends PropsWithChildren<_ReactPixi.IContainer> {
}

const clipAsset: {[K in RingColour]: string} = {
    'BLUE': CLIP_BLUE,
    'GREEN': CLIP_GREEN,
    'RED': CLIP_RED,
    'YELLOW': CLIP_YELLOW,
};

const glow =  new GlowFilter({distance: 20, outerStrength: 5, alpha:1, color:0xff99dd});

export const ObjectivePanel = (props: ObjectivePanelProps) => {
    const {localPlayer} = usePlayers();
    const playerObjectives = usePlayerObjectives(localPlayer.playerId);
    const handWritingFont = Assets.get<FontFace>(WRITING_FONT).family;

    const activeObjective = useMemo(() =>
        playerObjectives.find(o => o.ringId === undefined)
    , [playerObjectives]);

    // console.log('ObjectivePanel with', playerObjectives);
    const rings = useMemo(() => {
        return playerObjectives.map((objective, index) =>
            <Fragment key={index}>
                {objective.ringId &&
                    <RingSprite ringId={objective.ringId} key={'ring_' + index}
                        anchor={.5} y={195} x={65 + index * 60}/>
                }
                <Sprite texture={Assets.get(clipAsset[objective.ringColour])} key={'clip_' + index}
                    anchor={.5} y={160} x={65 + index * 60} width={50} height={50}
                    filters={objective === activeObjective ? [glow] : []}
                />
            </Fragment>,
        );
    }, [playerObjectives, activeObjective]);

    return (
        <Container {...props}>
            <Sprite texture={Assets.get(POSTIT)}/>
            <Text text={'Personal Objective'} style={textStyle({
                fontWeight: 'normal', fontFamily: handWritingFont, align: 'left',
                fill: '#00f', wordWrap: true, wordWrapWidth: 400,
            })} x={35} y={60}/>
            {playerObjectives.length > 0 &&
                <Text text={'Attach a ring to each clip'} style={textStyle({
                    fontWeight: 'normal', fontFamily: handWritingFont, align: 'left',
                    fill: '#00f', wordWrap: true, wordWrapWidth: 400, fontSize: 18,
                })} x={35} y={95}/>
            }
            {rings}
        </Container>
    );
};
